import _JSXStyle from "styled-jsx/style";
import { colors } from '@dhis2/ui-constants';
import React from 'react';
import { useDebugInfo } from './use-debug-info.js';
const formatDebugInfoKey = key => {
  const tokens = key.split('_');
  return tokens.map(token => {
    if (token.toLowerCase() === 'dhis2') {
      return 'DHIS2';
    } else {
      return token[0].toUpperCase() + token.substr(1).toLowerCase();
    }
  }).join(' ');
};
export function DebugInfoTable() {
  const debugInfo = useDebugInfo();
  return /*#__PURE__*/React.createElement("table", {
    'data-test': 'dhis2-ui-headerbar-debuginfotable',
    className: _JSXStyle.dynamic([["4076206425", [colors.grey700]]])
  }, /*#__PURE__*/React.createElement("tbody", {
    className: _JSXStyle.dynamic([["4076206425", [colors.grey700]]])
  }, Object.keys(debugInfo).map(key => /*#__PURE__*/React.createElement("tr", {
    key: key,
    className: _JSXStyle.dynamic([["4076206425", [colors.grey700]]])
  }, /*#__PURE__*/React.createElement("td", {
    className: _JSXStyle.dynamic([["4076206425", [colors.grey700]]]) + " " + "debug-info-key"
  }, formatDebugInfoKey(key)), /*#__PURE__*/React.createElement("td", {
    className: _JSXStyle.dynamic([["4076206425", [colors.grey700]]])
  }, debugInfo[key])))), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "4076206425",
    dynamic: [colors.grey700]
  }, [`table.__jsx-style-dynamic-selector{white-space:pre-wrap;font-size:14px;line-height:1.2;color:${colors.grey700};font-famile:Menlo,Courier,monospace !important;}`, "td.__jsx-style-dynamic-selector{padding-block:3px;padding-inline-end:16px;padding-inline-start:0;}", ".debug-info-key.__jsx-style-dynamic-selector{font-weight:bold;}"]));
}